/** Created by azhou on 2019/2/15.*/
<template>
  <div class="choose-box">
    <span v-if="leftText" :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
    <div class="choose-box text-left" v-if="leftText">
      <div class="form-left-text" :style="{width:width+'px'}">{{leftText}}</div><span>：</span>
    </div>
    <div class="input-self" v-if="type!=='textarea'" style="text-align:left;">
      <div class="facility">
        <p v-for="item in $verify.stitch(value)" :key="item">{{ item| formatVar(formatVar) }} <i class="el-icon-close" @click="vulueDelete(item)"></i> </p>
      </div>
      <el-popover
        placement="right"
        width="350"
        v-model="visible"
        trigger="click"
        @hide="hideEvent"
        >
            <el-checkbox-group class="groups" v-model="valueInside">
                  <el-checkbox  v-for="item in options"
                    :key="item.id"
                    :label="item.id"
                    :value="item.id">{{item.name}}</el-checkbox>
            </el-checkbox-group>  
            <div class="d-confirm">
              <p @click="onChange()">确认</p>
            </div>
        <el-button slot="reference" size="small" type="primary">{{$verify.stitch(value) .length>0?'重新选择':'选择'}}</el-button>
      </el-popover>
      <!-- <span class="" >(已选{{valueInside.length }}个)</span> -->
    </div>
  </div>  
</template>
<script>
  export default {
    name: 'LeftTextBorder',
    props: {
      value: {

      },
       width: {
        type: Number,
        default:100
      },
      type: {
        type: String,
        default: 'text'
      },
      formatVar: {
        type: String,
        default: 'text'
      },
      leftText: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    data(){
      return {
        valueInside: [],
        visible: false,
      }
    },
    watch:{
      value: {
        handler(newVal, oldVal) {
          if(newVal){
              this.valueInside=this.$verify.stitch(newVal);
          }
        },
        immediate: true 
      }
    },
    mounted() {
      if (this.value) {
        if (this.value instanceof Array) {
          this.valueInside = this.value;
        } else {
          this.valueInside = this.value.split(",");
        }
      }
    },
    methods:{
      //选择框隐藏时间
      hideEvent(){
        console.log('hide')
        this.valueInside=this.$verify.stitch(this.value);
      },
      //确认选择
      onChange() {
        if (this.value instanceof Array) {
          this.$emit("input", this.valueInside);
        } else {
          this.$emit("input", this.valueInside.join(","));
        }
        this.visible=false
      },
      //删除选择
      vulueDelete(item){
        this.valueInside.splice(this.valueInside.indexOf(item),1);
        this.onChange();
      },
      //输入框
      inputs(val,index){
        this.source[index]=val;
        this.inputData(this.source);
      },
      //添加多个
      addSource(){
        if(this.source.length>=4){return}
        this.source.push('');
        this.inputData(this.source);

      },
      //更新数据
      inputData(value){
        value=value.join(',');
        this.$emit('input',value);
        this.$emit('blur',value);
        this.$emit('enter',value)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .yls{
    color: #666;
    font-size: 12px;
    margin-left: 12px;
  }
  .narrow{
    input{
      height: 24px!important;
    }
  }
  .smallInput{
    height: 24px!important;
    line-height: 24px!important
  }
  .input-self {
    width: 100%;
    box-sizing: border-box;
    display: block;
    color: #606266;
    flex: 1;
    input,textarea{
      border: 1px solid #dcdfe6;
      padding: 3px 0px;
      appearance: none;
      width: 94%;
      padding: 0 3%;
      border-radius: 3px;
      font-size: 14px;
      line-height: 32px;
      &:focus{
        outline: none;
        border: 1px solid #26a2ff;
      }
    }
    input{height: 31px;}
    textarea{
      height: 80px;
      resize: none;
    }
  }
  .append{
    background-color: #f5f7fa;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border: 1px solid #dcdfe6;
    border-left: 0;
    font-size: 14px;
    padding: 3px 0;
    border-radius: 4px;
    width: 60px;
    white-space: nowrap;
    height: 24px;
    line-height: 24px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    text-align: center
  }
  .many{
    cursor: pointer;
    background-color: var(--smtc-color-primary);
    width: 80px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    font-size: 12px;
    color: #fff;
    text-align: center;
  }
    .red{
    color: red;
  }
  .many-input{
    display: flex;
    margin-bottom: 6px;
  }
  .input-self .many-input:last-child{
    margin-bottom: 0;
  }
  .hs{
    color: #eee;
  }
  .groups {
    display: flex;
    flex-wrap: wrap;
  }
  .d-confirm{
    width: 100%;
    overflow: hidden;
    border-top: 1px #eee solid;
    padding-top: 6px;
    margin-top: 6px;
  }
  .d-confirm p{
    width: 80px;
    height: 34px;
    background-color: var(--smtc-color-primary);
    color: #fff;
    margin: 0 auto;
    text-align: center;
    line-height: 34px;
    border-radius: 6px;
    cursor: pointer;
  }
  .facility{
    display: flex;
    width: 100%;
    flex-wrap: wrap;
  }
  .facility p{
    padding: 0px 0 0 4px;
    margin-right: 6px;
    border-radius: 4px;
    border: 1px #eee solid;
    font-size: 12px;
    margin-bottom: 6px;
    line-height: 20px;
  }
  .facility p i{
    cursor: pointer;
    padding: 8px 0;
    padding-right: 4px;
  }
  .choose-box{
    display: flex;
  }
  .text-left{
    line-height: 24px;
    margin-top: 8px;
  }
  .text-left span{
    margin-top: -5px; 
  }
</style>
<style>
  .groups .el-checkbox__label{
    width: 70px;
  }
  .groups .el-checkbox:nth-child(3n){
    margin-right: 0;
    margin-bottom: 4px;
  }
</style>